import React from "react";
import styled from "styled-components";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { OptionType, ValueType } from "@sonder/ui/source/styled/types";

const Container = styled.div`
  display: flex;
  align-items: center;
  > *:not(:last-child) {
    margin-right: 0.6rem;
  }
`;

interface ButtonSelectorProps {
  options: OptionType[];
  className?: string;
  selected?: ValueType;
  required?: boolean;
  onChange: (value: ValueType) => void;
}
export const ButtonSelector = ({
  options,
  selected,
  onChange,
  className,
  required,
}: ButtonSelectorProps) => {
  const handleChange = (value: ValueType) =>
    onChange(selected === value && !required ? null : value);

  return (
    <Container className={className}>
      {options?.map(option => (
        <Button
          key={option.displayName}
          selected={selected === option.value}
          onClick={() => handleChange(option.value)}
        >
          {option.displayName}
        </Button>
      ))}
    </Container>
  );
};
